import { STags } from 'shj-components';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';

const statusEnum = {
  WAIT: '待生成',
  PROGRESSING: '生成中',
  COMPLETED: '生成完成',
  ERROR: '错误'
}

const colorKeyMap = {
  COMPLETED: 'completed',
  WAIT: 'expired',
  PROGRESSING: 'inService',
  ERROR: 'returnOrder'
}

export const config = {
  rowSelection: false,
  pagination: true,
  pageSizeOptions: [6],
  columns: [
    {
      title: '提交记录',
      dataIndex: 'batchKey',
      width: 220,
      name: 'batchKey',
    },
    {
      title: '数据批次',
      dataIndex: 'batchIndex',
      width: 120,
      name: 'batchIndex',
    },
    {
      title: '数据量',
      dataIndex: 'skuSize',
      width: 120,
      name: 'skuSize',
    },
    {
      title: '创建时间',
      width: 180,
      dataIndex: 'createdTime',
      itemType: 'dateTime',
    },
    {
      title: '状态',
      dataIndex: 'status',
      width: 110,
      name: 'status',
      fixed: 'right',
      render: (text) => <span>{ <STags itemKey={colorKeyMap[text]} icon={text === 'PROGRESSING' ? <Spin indicator={<LoadingOutlined spin /> } /> : null} label={statusEnum[text]} /> }</span>
    },
    { title: '操作', dataIndex: '#', width: 100, fixed: 'right', render: 'actionRender' },
  ],
  search: [
  ],
  footer: [
  ],
}
